import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, Spacer } from '../styles';

const VocationOnePresentationPage = ({ user, background, number }) => {
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='right-content'>
          <h1>
            ¡Hola <span className='capitalized'>{user.name.toLowerCase()}</span>
            !
          </h1>
          <p className='justified'>
            Este informe resume los resultados que obtuviste al responder el
            Test Vocation Junior. Su propósito es entregarte información para
            que puedas comenzar a explorar tus intereses vocacionales, conocer
            tus preferencias para las asignaturas de profundización que pronto
            deberás escoger y conocer más sobre tus motivaciones y estrategias
            de estudio. Toda esta información puede ser muy útil para las guiar
            las decisiones que debes ir tomando en tu última etapa escolar.
          </p>

          <h2>Orientación Vocacional</h2>
          <p className='justified'>
            El Test Vocation Junior entrega información sobre tus{' '}
            <strong>principales preferencias vocacionales</strong>, es decir,
            temas o áreas que te pueden resultar más atractivas para trabajar en
            el futuro. Con esta información puedes empezar a reflexionar e
            investigar qué carreras o profesiones podrían gustarte más cuando
            salgas del colegio.
          </p>

          <h2>Asignaturas de profundización</h2>
          <p className='justified'>
            Prontamente deberás elegir tres asignaturas de profundización, de
            acuerdo a tus intereses personales y/o proyecto de vida. El Test
            Vocation Junior te entrega información sobre las{' '}
            <strong>
              áreas en las que te gustaría aprender más o desarrollar más
              habilidades
            </strong>
            . Esta información te será útil para elegir tus asignaturas de
            profundización con más información y mayor claridad.
          </p>

          <h2>Aproximaciones al estudio</h2>
          <p className='justified'>
            El Test Vocation Junior te entrega, además, información respecto de
            la{' '}
            <strong>
              forma en que te enfrentas a tus procesos de aprendizaje
            </strong>
            , identificando las principales motivaciones que tienes para
            estudiar, y las principales formas en que estudias. Saber qué te
            motiva para estudiar y cómo estudias te servirá para identificar si
            puedes ajustar algunas estrategias para lograr tus metas académicas.
          </p>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationOnePresentationPage;
